<template>
    <v-col>
      <div v-for="value in processusKeys" :key="value">
        <h1>{{ value }}</h1>
        <v-card
          class="d-flex align-content-start flex-wrap"
          flat
          tile
          min-height="100"
        >
          <v-card
            v-for="n in processus[value]"
            :key="n.id"
            class="pa-2"
            outlined
            tile
            min-width="200px"
            max-width="200px"
          >
          <router-link :to="n.route" style="text-decoration:none; ">
            <div>
              <div class="text-center">
                <br />
                <!-- <v-badge color="pink" content="i" bottom> -->
                  <v-badge :color="n.count <= 0 ? 'transparent' : 'primary'" :content="n.count">
                    <v-btn fab elevation="1" color="#32a68c"
                      ><v-icon>{{n.icon}}</v-icon></v-btn
                    >
                  </v-badge>
                <!-- </v-badge> -->

                <!-- <div class="float-sm-right red"><v-btn color="info" fab x-small elevation="0">i</v-btn></div> -->
              </div>
            </div>
            <div class="text-center">
              <br />
              {{ n.name }}
            </div>
            </router-link>
          </v-card>
        </v-card>
      </div>
      </v-col>
</template>

<script>
export default {
    props:
    {
        processusKeys: Array,
        processus: Object
    }
}
</script>
